import { Component, EventEmitter, inject, Output, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { MatInput, MatPrefix } from '@angular/material/input';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { debounceTime, switchMap, catchError } from 'rxjs/operators';
import { RegistrierungService } from '../../services/registrierung.service';
import { OsmAdresse } from '../../generated-model/osmAdresse';
import { TranslatePipe } from '@ngx-translate/core';
import { AdresseMTO } from '../../generated-model/adresseMTO';
import { of } from 'rxjs';

@Component({
  selector: 'app-adress-suche',
  imports: [MatFormField, MatIcon, MatInput, ReactiveFormsModule, MatPrefix, TranslatePipe],
  templateUrl: './adress-suche.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './adress-suche.component.scss',
})
export class AdressSucheComponent implements OnInit {
  @Output() adressChanged = new EventEmitter<OsmAdresse>();

  private readonly registrierungService = inject(RegistrierungService);
  private readonly formBuilder = inject(FormBuilder);

  searchInputControl: FormControl<string | null> = this.formBuilder.control('');
  searchResult = signal<OsmAdresse[]>([]);

  constructor() {
    this.searchInputControl.setValue('');
  }

  ngOnInit() {
    // Initialize the signal from valueChanges in ngOnInit to ensure proper setup
    const searchResult$ = this.searchInputControl.valueChanges.pipe(
      debounceTime(500),
      switchMap(() =>
        this.registrierungService.doOSMAdressPruefungBySuchString(this.searchInputControl.value ?? '').pipe(
          catchError((error) => {
            console.error('Address search error:', error);
            return of([] as OsmAdresse[]);
          })
        )
      )
    );

    // Subscribe directly to update the signal
    searchResult$.subscribe((results) => {
      this.searchResult.set(results);
    });
  }

  onSelectAdresse(adresseMTO: AdresseMTO) {
    this.adressChanged.emit(adresseMTO);
    this.searchInputControl.setValue('');
  }
}
